const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de clientes',
  PAGE_DESCRIPTION:
    'En este apartado puedes visualizar todos los clientes que tienes dados de alta. También cuentas con las opciones de "Crear nuevo cliente"  y "Editar cliente".'
};

export default HELPER_TEXTS;
